export default {
  incorrect_cvc: "Sikkerhedskoden er ikke korrekt.",
  card_declined: "Kortet blev afvist.",
  expired_card: "Kortet er udløbet.",
  processing_error: "Kortet kunne ikke behandles. Prøv igen senere.",
};
